import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ProjectBidService } from '../Services/projectbid.service';
import { ProjectBid } from '../objects/ProjectBid';
import { BidContact } from '../objects/BidContact';
import { Contractor } from '../objects/Contractor';
import { ProjectType } from '../objects/ProjectType';
import { ProjectTypeService } from '../Services/project-type.service';

@Component({
  selector: 'app-project-bid-add',
  templateUrl: './project-bid-add.component.html',
  styleUrls: ['./project-bid-add.component.css'],
})
export class ProjectBidAddComponent implements OnInit {

  projectTypes: ProjectType[] = [];

  private defaultContractor: Contractor = {
    id: 0, name: '', age: 0, jobTitle: '',
    cellPhone: '', email: '', salary: 0, hourlyWage: 0, imageContent: ''
  };

  newProjectBid: ProjectBid = {
    id: 0,
    companyName: '',
    contractor: this.defaultContractor,
    bidAmount: 0,
    projectTypeId: null as any,
    projectDetails: '',
    projectType: { id: 0, type: '' },
    status: '',
    contacts: [],
  };

  // ── Contact management ─────────────────────────────────────────
  contacts: BidContact[] = [];
  showContactForm = false;
  newContact: BidContact = { name: '', title: '', email: '', phone: '' };

  constructor(
    private router: Router,
    private projectBidService: ProjectBidService,
    private projectTypeService: ProjectTypeService
  ) {}

  ngOnInit() {
    this.getProjectTypes();
  }

  getProjectTypes() {
    this.projectTypeService.getProjectTypes().subscribe((result) => {
      this.projectTypes = result;
    });
  }

  onProjectTypeChange(id: number) {
    const found = this.projectTypes.find(t => t.id == id);
    if (found) {
      this.newProjectBid.projectType = { ...found };
      this.newProjectBid.projectTypeId = found.id;
    }
  }

  addContact(): void {
    if (!this.newContact.name.trim()) { return; }
    this.contacts.push({ ...this.newContact });
    this.newContact = { name: '', title: '', email: '', phone: '' };
    this.showContactForm = false;
  }

  cancelContact(): void {
    this.newContact = { name: '', title: '', email: '', phone: '' };
    this.showContactForm = false;
  }

  removeContact(index: number): void {
    this.contacts.splice(index, 1);
  }

  goBack() {
    this.router.navigate(['/project-bids']);
  }

  saveProjectBid() {
    const payload: ProjectBid = { ...this.newProjectBid, contacts: [...this.contacts] };
    this.projectBidService.addProjectBid(payload).subscribe(() => {
      this.router.navigate(['/project-bids']);
    });
  }
}
